import { Group, Stack } from '@mantine/core';
import { randomId } from '@mantine/hooks';
import { IconPlus } from '@tabler/icons-react';
import FormInputGroup from 'components/forms/FormInputGroup';
import P2Medium from 'components/typography/P2Medium';
import TechnicianPairingRow from 'components/forms/remote-source/config/chastia-config-form/technicians/TechnicianPairingRow';
import { ChastiaConfigForm } from 'components/forms/remote-source/config/types';
import Button from 'components/Button';

interface TechniciansProps {
  form: ChastiaConfigForm;
}

/**
 * Sub-form for Technician pairings.
 */
export default function Technicians({ form }: TechniciansProps) {
  const technicians = form.values.technicians ?? [];

  return (
    <FormInputGroup groupTitle="Mapovanie Technikov">
      <Stack spacing={8}>
        <Group className="grid max-w-[972px] grid-cols-[1fr_24px_1fr_44px] items-center gap-y-0">
          <P2Medium>ID Chastia</P2Medium>
          <div></div>
          <P2Medium>Používateľ</P2Medium>
        </Group>

        {technicians.map((item, index) => (
          <TechnicianPairingRow key={item.key} form={form} item={item} index={index} />
        ))}

        <Group mt={8}>
          <Button
            size="md"
            leftIcon={<IconPlus />}
            onClick={() => form.insertListItem('technicians', { key: randomId() })}
          >
            Pridať riadok
          </Button>
        </Group>
      </Stack>
    </FormInputGroup>
  );
}
